'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$18(evaluator$14) {
  this.Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$18__f_evaluator$6 = null;
  this.Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$18__f_evaluator$6 = evaluator$14;
}
export { $c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$18 as $c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$18 };
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$18.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$18.prototype.constructor = $c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$18;
/** @constructor */
function $h_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$18() {
}
export { $h_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$18 as $h_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$18 };
$h_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$18.prototype = $c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$18.prototype;
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$18.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$18.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$18__f_evaluator$6.apply__O();
  return ((v instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_data_FrameworkDateTime) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$18.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$18 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$18, "app.api.DrugRequestPharmacyState$ResponseGiven$$anon$18", ({
  Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$18: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$18 as $d_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$18 };
//# sourceMappingURL=app.api.-Drug-Request-Pharmacy-State$-Response-Given$$anon$18.js.map
